// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type DispatchCustomerMatchInfo,
  type DispatchCustomerMatchInfoWireFormat,
  NewDispatchCustomerMatchInfo,
} from '../DispatchCustomerMatchInfo/DispatchCustomerMatchInfo';

export class UnmergedDispatchCustomer {
  readonly id: string;
  readonly name: string;
  readonly matchInfo: DispatchCustomerMatchInfo[] | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.matchInfo =
      // eslint-disable-next-line no-nested-ternary
      (data.matchInfo ?? null) === null
        ? null
        : (data.matchInfo ?? []).map((matchInfo: any) => NewDispatchCustomerMatchInfo(matchInfo));
  }

  static zero(): UnmergedDispatchCustomer {
    const zeroValues: ExcludeMethodsDeep<UnmergedDispatchCustomer> = {
      id: NIL_UUID,
      name: '',
      matchInfo: null,
    };
    return new UnmergedDispatchCustomer(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type UnmergedDispatchCustomerWireFormat = {
  id: string;
  name: string;
  matchInfo: DispatchCustomerMatchInfoWireFormat[] | null;
};

type NewUnmergedDispatchCustomerProps = PartialDeep<
  UnmergedDispatchCustomer,
  { recurseIntoArrays: true }
>;
export const NewUnmergedDispatchCustomer: (
  props: NewUnmergedDispatchCustomerProps,
) => UnmergedDispatchCustomer = (props) => new UnmergedDispatchCustomer(props);

type NewUnmergedDispatchCustomerFromWireFormatProps = PartialDeep<
  UnmergedDispatchCustomerWireFormat,
  { recurseIntoArrays: true }
>;
export const NewUnmergedDispatchCustomerFromWireFormat: (
  props: NewUnmergedDispatchCustomerFromWireFormatProps,
) => UnmergedDispatchCustomer = (props) => new UnmergedDispatchCustomer(props);
